import { QESButton } from "@app/shared/qes-standards";
import { FC, useContext, useMemo, useRef } from "react";
import { JobLineChart } from "./JobLineChart";
import { JobStastiticsContext } from "./JobStatisticsContext";
import { resizeChartToFitLabels } from "./resizeChart";
import { UserDefinedChartModel } from "./types";
import { QesIcon } from "@app/shared/icons/QESIcon";
import { QesIcons } from "@app/shared/icons/qesIcons";

interface UserDefinedJobLineChartWrapperProps {
    chartModel: UserDefinedChartModel;
}


export const UserDefinedJobLineChartWrapper: FC<React.PropsWithChildren<UserDefinedJobLineChartWrapperProps>> = (props: UserDefinedJobLineChartWrapperProps) => {
    const maxXAxisValue = useMemo(() => {
        return Math.max.apply(null, props.chartModel.dataPoints?.map((dp) => dp.xAxisValue));
    }, [props.chartModel.dataPoints]);
    const minXAxisValue = useMemo(() => {
        return Math.min.apply(null, props.chartModel.dataPoints?.map((dp) => dp.xAxisValue));
    }, [props.chartModel.dataPoints]);
    const context = useContext(JobStastiticsContext);
    const containerRef = useRef<HTMLSpanElement>(null);

    return (
        <span ref={containerRef}>
            {/* I thought a label would make sense for the chart's title, but WCAG specify a label should be associated with an input. So, span.*/}
            <span className="job-chart__title">{props.chartModel.metadata.name}</span>
            <QESButton
                className="job-chart__refresh"
                qesType="secondary"
                qesTestId={`job-chart__refresh-${props.chartModel.metadata.chartId}`}
                onClick={() => context.refreshUserDefinedChart(props.chartModel.metadata.chartId)}
            >
                <QesIcon iconName={QesIcons.FontAwesome.Refresh} width="12" height="14" description="refresh chart" />
            </QESButton>
            <QESButton
                className="job-chart__resize"
                qesType="secondary"
                qesTestId={`job-chart__resize-${props.chartModel.metadata.chartId}`}
                onClick={() => resizeChartToFitLabels(containerRef.current)}
                disabled={props.chartModel.dataPoints.length === 0}
            >
                <QesIcon iconName={QesIcons.FontAwesome.ArrowsVertical} width="6" height="14" description="resize chart" />
            </QESButton>
            <QESButton
                className="job-chart__delete"
                qesType="secondary-danger"
                qesTestId={`job-chart__delete-${props.chartModel.metadata.chartId}`}
                onClick={() => context.deleteUserDefinedChart(props.chartModel.metadata.chartId)}
            >
                <QesIcon iconName={QesIcons.FontAwesome.TrashOutline} width="11" height="14" description="delete chart" />
            </QESButton>
            <JobLineChart
                dataPoints={props.chartModel.dataPoints}
                yAxisLabel={props.chartModel.metadata.yAxis}
                domain={[minXAxisValue, maxXAxisValue]}
                xAxisLabel={props.chartModel.metadata.xAxis}
                errorMessage={props.chartModel.metadata.errorMessage}
            />
        </span>
    )
}
